export class ToroNotification {

    constructor(json: object = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            this.Id = this.Id === undefined ? this.NotificationId : this.Id;
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    public Id: string;
    public CallerType: string;
    public CallerId: number;
    public CallerUId: string;
    public IsCallerToroAdministrator: boolean;
    public IsAcknowledged: boolean;
    public ValueType: String;
    public AccountId: number;
    public LocationId: number;
    public RequiresAcknowledgment: boolean;
    public TypeCode: number;
    public NotificationId: string;
    private _timeStamp: Date;
    set TimeStamp(value: Date) {
        this._timeStamp = new Date(value);
    }
    get TimeStamp(): Date {
        return this._timeStamp;
    }

    private _readTime: Date;
    set ReadTime(value: Date) {
        this._readTime = new Date(value);
    }
    get ReadTime(): Date {
        return this._readTime;
    }

    private _expiration: Date;
    public set Expiration(value: Date) {
        this._expiration = new Date(value);
    }
    public get Expiration(): Date {
        return this._expiration;
    }

    private _whenToDelete: Date;
    public set WhenToDelete(value: Date) {
        this._whenToDelete = new Date(value);
    }
    public get WhenToDelete(): Date {
        return this._whenToDelete;
    }

    // Pretty Times are string representations of UTC DateTime
    public PrettyTimeStamp: string;
    public PrettyExpiration: string;
    public PrettyDeleteTime: string;

    private _value: any;
    public set Value(v: any) {
        this._value = JSON.parse(v);
    }
    public get Value(): any {
        return this._value;
    }
}


